import type { RouteRecordRaw } from 'vue-router/auto'
import type { PortalRole } from '@/utils/portalRoles'
import { landingRoute } from '@/utils/portalRoles'

// 👉 Redirects
export const redirects: RouteRecordRaw[] = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const userData = useCookie<{ roles?: PortalRole[] } | null | undefined>(
        'userData',
      )

      const roles = userData.value?.roles ?? []

      if (roles.length === 0)
        return { name: 'login', query: to.query }

      // Both roles land on the orders list. An admin gets every order, a driver the ones
      // assigned to them, and the driving view on that page is where they work.
      return { name: landingRoute() }
    },
  },
]

export const routes: RouteRecordRaw[] = [
  {
    path: '/dashboards/logistics',
    name: 'dashboards-logistics',
    component: () => import('@/pages/apps/logistics/dashboard.vue'),
  },
]
